import { useCallback } from "react";
import { exportDiagramPNG } from "@/lib/chat/exportDiagramPNG";

export function useVennDiagramExport(
  canvasRef: React.RefObject<HTMLElement | null>,
  title: string
) {
  const exportPNG = useCallback(async () => {
    const el = canvasRef.current;
    if (!el) return;
    await exportDiagramPNG(el, title + "_venndiagram");
  }, [canvasRef, title]);

  return { exportPNG };
}
